module.exports = __webpack_public_path__ + "gl.86f56559.svg";